export type HttpMethod = 'GET' | 'POST' | 'PUT' | 'PATCH' | 'DELETE' | 'OPTIONS' | 'HEAD';

export async function connection<T>(
  url: string,
  method: HttpMethod = 'GET',
  headers: Record<string, string> = {},
  body: any = null,
  cookies?: string,
  cache: boolean = false, // solo usado en SSR
  isBlob: boolean = false
): Promise<T> {
  const allHeaders: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(cookies && { Cookie: cookies }),
    ...headers,
  };

  if (cookies) {
    allHeaders['Cookie'] = cookies;
  }

  const options: RequestInit = {
    method,
    headers: allHeaders,
    credentials: 'include', // funciona en frontend
  };

  if (body) {
    options.body = JSON.stringify(body);
  }

  if (!cache) {
    options.cache = 'no-store';


  }

  const res = await fetch(url, options);

  if (!res.ok) {
    let errorBody = await res.text();
    try {
      errorBody = JSON.parse(errorBody);
    } catch {
      errorBody = errorBody
    }

    const error: any = new Error(`Error: ${res.status} ${res.statusText}`);
    error.status = res.status;
    error.info = errorBody;
    throw error;
  }

  if (isBlob) {
    return await res.blob() as unknown as T;
  }

  return await res.json();
}
